export type TripAddress = {
  name?: string;
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  formatted?: string;
  passenger_instructions?: string | null;
};
export type TripStop = {
  id: string;
  label: string;
  kind: 'pickup' | 'stop' | 'dropoff';
  address: TripAddress;
  planned_at?: string | null;
  timezone?: string;
  passenger_instructions?: string | null;
};
export type TripSegment = {
  id: string;
  label: string;
  start_at: string;
  end_at: string;
  timezone: string;
  passenger_count?: number | null;
  stops: TripStop[];
  passenger_instructions?: string | null;
};
export type TripDetails = {
  timezone?: string;
  passenger_count?: number | null;
  passenger_instructions?: string | null;
  internal_notes?: string | null;
  dispatch_notes?: string | null;
  actual_pickup_at?: string | null;
  actual_dropoff_at?: string | null;
  stops?: any[];
  segments?: TripSegment[];
  [key: string]: any;
};

export function changedTripFields(
  original: TripDetails,
  next: TripDetails
): Partial<TripDetails> {
  return Object.fromEntries(
    Object.entries(next).filter(
      ([key, value]) => JSON.stringify(value) !== JSON.stringify(original[key])
    )
  );
}
